import React, {useCallback, useEffect, useState} from 'react'
import axios from 'axios'
import {toast} from 'react-toastify'
import {API_ENDPOINTS} from '../../../../constants/apiConstants'
import {useReduxAuth} from '../../../auth'
import LoaderComponent from '../../components/LoaderComponent'
import {
  DOCTOR_TRANSACTION_HEADERS,
} from '../../../../constants/RoleConstants'
import DataTableList from '../../components/DataTableList'
import {filterHeadersByUserRole} from '../../helper/helperFunction'
import MetaTags from '../../../../meta/MetaTags'

const PaymentHistory = () => {
  const {currentUser} = useReduxAuth()

  const [doctorTransactions, setDoctorTransactions] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  // function to get data
  const fetchData = useCallback(async () => {
    setIsLoading(true)
    try {
      const response = await axios.get(
        currentUser?.userRole === 'doctor'
          ? API_ENDPOINTS.GET_DOCTOR_TRANSACTIONS(currentUser?.uuid!)
          : API_ENDPOINTS.GET_ALL_TRANSACTIONS()
      )

      if (response.data.status === 'Success') {
        setDoctorTransactions(response.data?.data?.transactions || [])
      } else {
        toast.error(response.data.message || 'Failed to fetch data.')
      }
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      } else if (error instanceof Error) {
        toast.error(error.message)
      } else {
        toast.error('An unexpected error occurred')
      }
    } finally {
      setIsLoading(false)
    }
  }, [currentUser])

  // fetch data
  useEffect(() => {
    fetchData()
  }, [fetchData])

  if (isLoading) return <LoaderComponent />

  // Function to filter headers based on user permissions
  const filteredHeaders = filterHeadersByUserRole(DOCTOR_TRANSACTION_HEADERS, currentUser)

  return (
    <>
    <MetaTags title={'Payment History'} />
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header d-flex justify-content-between align-items-center'>
        {/* Title */}
        <div className='card-title m-0 '>
          <h3 className='fw-bolder m-0'>Payment History</h3>
        </div>
      </div>

      <div className='card-body p-9'>
        <DataTableList
          columns={filteredHeaders}
          data={doctorTransactions}
          showAddButton={false}
          showHeader={false}
        />
      </div>
    </div>
    </>
  )
}

export default PaymentHistory
